import { l } from '@manychat/manyui'

import { TriggerEventTypeLabels } from 'apps/triggerRules/models/TriggerRule/constants'
import { ITriggerRule } from 'apps/triggerRules/triggerRulesInterfaces'
import { ConverterRule } from 'common/builder/components/chart/FlowChart/lib/types'
import {
  FlowChartTrigger,
  FlowChartTriggerIconType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartTrigger'
import { getTriggerConfig } from 'common/builder/utils/getTriggerConfig'
import { isTriggerInteractive } from 'common/builder/utils/isTriggerInteractive'
import { TriggerType } from 'common/flow/constants/TriggerType'
import { IFlowTrigger } from 'common/flow/flowInterfaces'

export const RuleGenericTriggerConverterRule: ConverterRule<IFlowTrigger, FlowChartTrigger> = {
  predicate: (entity: IFlowTrigger) => entity?.triggerType === TriggerType.RULE,
  convert: (entity: ITriggerRule) => {
    const triggerConfig = getTriggerConfig(entity)

    const triggerLabels = entity.triggers.map((trigger) =>
      l.getString(TriggerEventTypeLabels[trigger?.data?.event_type]),
    )

    const subtitle = triggerLabels.length === 0 ? [l.translate('Set up event')] : triggerLabels

    const trigger: FlowChartTrigger = {
      title: l.getString(triggerConfig?.description) || l.translate('Empty'),
      id: entity.triggerId,
      icon: {
        type: FlowChartTriggerIconType.ICON,
        icon: triggerConfig?.icon || null,
      },
      subtitle,
      subtitleIcon: null,
      isActive: entity.enabled,
      isInteractive: isTriggerInteractive(entity),
    }

    return trigger
  },
}
